import { SourceEntity } from '../entities/source-entity';

export default class State {
  loaded = false;

  items: Array<SourceEntity> = [];
}
